<template>
  <div class="welcome">
    <p style="text-align: left;">You and your opponent can connect using this page to share the same deck of card. <br>
                                 One of you should host by choosing a name and click "create", the other should enter the same name and click "join"<span class=""></span></p>
    <div class="text-field">
      <input type="text"
             placeholder="Enter the name of your game"
             v-model="gameName">
    </div>
    <p>
      <label><input type="checkbox" v-model="gameState.hasGameMaster">
        Game master mode</label>
    </p>

    <template v-if="!gameState.hasGameMaster">
      <p>Pick a side (only matters if you are creating the game):</p>
      <p>
        <side-selector :is-red="gameState.isMasterRed"
                       @toggle="gameState.isMasterRed = !gameState.isMasterRed"></side-selector>
      </p>
    </template>
    <div>
      <button class="btn" @click="createGame">Create</button>

      <button class="btn" @click="joinGame">Join</button>
    </div>
    <div class="alert" v-if="duplicateGame">Another game with the same name already exists.</div>

    <div class="deck-content">
      <h2>Deck content</h2>
      <div class="card-colors">
        <div class="red">
          <h3>Red</h3>
          <table>
            <thead>
            <tr>
              <th>Type</th>
              <th>Qty</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="card in redCards.filter(x => !x.isQuantityFixed)" v-bind:key="card.id">
              <td>{{ card.name }}</td>
              <td>
                <div style="display: flex; align-items: center;">
                  <quantity-selector :quantities="card.possibleValues"
                                     :default-qty="card.defaultQuantity"
                                     :quantity="card.quantity"
                                     @selectionChanged="qty => card.quantity = qty"></quantity-selector>
                </div>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <td colspan="2" align="right">
                <button @click="clearRedQuantity">clear</button>
              </td>
            </tr>
            </tfoot>
          </table>
        </div>
        <div class="blue">
          <h3>Blue</h3>
          <table>
            <thead>
            <tr>
              <th>Name</th>
              <th>Qty</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="card in blueCards.filter(x => !x.isQuantityFixed)" v-bind:key="card.id">
              <td>{{ card.name }}</td>
              <td>
                <div style="display: flex; align-items: center;">
                  <quantity-selector :quantities="card.possibleValues"
                                     :default-qty="card.defaultQuantity"
                                     :quantity="card.quantity"
                                     @selectionChanged="qty => card.quantity = qty"></quantity-selector>
                </div>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <td colspan="2" align="right">
                <button @click="clearBlueQuantity">clear</button>
              </td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import GameState from '@/models/GameState';
import Cards from '@/models/Cards';
import Card from '@/models/Card';
import QuantitySelector from '@/components/QuantitySelector';
import SideSelector from '@/components/SideSelector';

export default {
  props: {
    duplicateGame: {
      type: Boolean,
    },
  },
  components: {
    QuantitySelector,
    SideSelector,
  },
  data() {
    return {
      gameName: '',
      gameState: new GameState(),
      cards: [...Cards],
    };
  },
  computed: {
    redCards() {
      return this.cards.filter(x => x.isRed);
    },
    blueCards() {
      return this.cards.filter(x => x.isBlue);
    },
  },
  methods: {
    generateUUID() {
      let uuid = '';
      let random = null;
      for (let i = 0; i < 32; i += 1) {
        random = Math.random() * 16 | 0; // eslint-disable-line

        if (i === 8 || i === 12 || i === 16 || i === 20) {
          uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16); // eslint-disable-line
      }
      return uuid;
    },
    createGame() {
      //
      // Build the deck
      //
      const deck = this.cards.filter(x => x.quantity > 0).reduce((mem, x) => {
        for (let i = 0; i < x.quantity; i += 1) {
          mem.push(new Card({ ...x, uuid: this.generateUUID() }));
        }
        return mem;
      }, []);
      this.gameState.deck = deck.sort(() => Math.random() > 0.5 ? 1 : -1);

      // eslint-disable-next-line no-debugger
      this.$emit('create', { gameName: this.gameName, gameState: this.gameState });
    },
    joinGame() {
      this.$emit('join', this.gameName);
    },
    clearRedQuantity() {
      for (let card of this.redCards) {
        card.quantity = 0;
      }
    },
    clearBlueQuantity() {
      for (let card of this.blueCards) {
        card.quantity = 0;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.welcome {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  .text-field {
    margin-bottom: 2vw;

    input {
      font-size: 1.4em;
      padding: 1vw 2vw;
      border: none;
      border-radius: 0.5vw;
      box-shadow: 0 1vw 1vw #00000033;
      text-align: center;
      tab-index: 0;
      width: 90vw;
    }
  }


  button {
    margin-right: 1.6em;
    font-size: 1.1em;
    padding: 0.6em 1.2em;
    font-weight: 400;
    margin-top: 0.5em;

    &:last-of-type {
      margin-right: 0;
    }
  }

  .alert {
    padding: 1.6vw 3.2vw;
    background: #a00000;
    color: #fff;
    border-radius: 0.5vw;
    font-size: 1.4vw;
    font-weight: 600;
    margin: auto;
    margin-top: 2vw;
  }

  .deck-content {
    text-align: left;
    width: 100%;

    h2 {
      text-align: center;
      border: solid 0.1rem #ffffff66;
      padding: 1.6rem;
      margin: 1.6rem;
    }

    input {
      font-size: 1.2rem;
      margin-right: 1.2rem;
      padding: 0.3rem 0rem;
    }

    button {
      padding: 0.3rem 1rem;
      margin-right: 0.6rem;
      width: 3rem;
    }

    .card-colors {
      display: flex;
      justify-content: space-around;

      > * {
        background: #ffffff33;
        padding: 0.8rem 3.2rem 1.6rem 3.2rem;

        h3 {
          text-align: center;
          padding: 0.6rem;
        }
      }

      .red {
        h3 {
          background: red;
        }
      }

      .blue {
        h3 {
          background: blue;
        }
      }

      th, td {
        padding: 0.3rem 0.6rem;
      }

      th:nth-of-type(2) {
        text-align: center;
      }

      button {
        border-radius: 0.6rem;
        background: #413a29;
        color: #ffffff99;
        width: auto;
        font-size: 0.9em;
        margin: 0;
        margin-top: 1rem;
      }
    }
  }
}
</style>
